/* unplugin-vue-components disabled */import { render } from "./StickyFooter.vue?vue&type=template&id=253304a2"
const script = {}

import "./StickyFooter.vue?vue&type=style&index=0&id=253304a2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__